import React from 'react';

const YouTubeShowcase = ({ 
  videoUrl = "https://youtu.be/RStvVOUjY00", 
  title = "Experience India's Best-Kept Secret", 
  description = "Discover Carneiro Wine from Vasai. Celebrate with friends and family with our signature home-made wines crafted through natural fermentation." 
}) => {
  // Helper to extract the YouTube video ID from various URL formats
  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const videoId = getYouTubeId(videoUrl);

  // Helper to split the title so the last word gets the theme's gold underline effect
  const words = title.split(' ');
  const lastWord = words.pop();
  const firstPart = words.join(' ');

  return (
    <section className="w-full bg-[--neutral-white] py-20 px-6 md:px-12 relative overflow-hidden">
      {/* Background sketch accents to match the theme */}
      <div className="absolute top-0 -left-10 opacity-[0.05]">
        <img 
          alt="decoration" 
          className="w-[200px]" 
          src="/static/media/grapes-sketch.dc6c6bf38d4cd621df5c.png" 
          onError={(e) => e.target.style.display = 'none'} 
        />
      </div>

      <div className="max-w-6xl mx-auto flex flex-col items-center relative z-10">
        
        {/* Themed Heading */}
        <h2 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] leading-tight text-center mb-4 relative z-10">
          <span className="text-[--neutral-black]">{firstPart} </span>
          <span className="relative inline-block text-[--neutral-black]">
            {lastWord}
            <span className="absolute bottom-1 left-0 w-full h-[6px] bg-[--accent-gold] -z-10 rounded-md"></span>
          </span>
        </h2>

        {/* Themed Description */}
        {description && (
          <p className="mt-3 text-gray-600 text-sm sm:text-base text-center max-w-2xl mb-12">
            {description}
          </p>
        )}

        {/* Video Container */}
        <div className="w-full max-w-4xl relative rounded-xl overflow-hidden shadow-2xl border-4 border-white group">
          {/* Decorative hover border effect using theme colors */}
          <div className="absolute inset-0 border-4 border-transparent group-hover:border-[--accent-gold] rounded-xl transition duration-500 z-20 pointer-events-none"></div>
          
          <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
            {videoId ? (
              <iframe
                className="absolute top-0 left-0 w-full h-full z-10 rounded-lg"
                src={`https://www.youtube.com/embed/${videoId}?rel=0&autoplay=0`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            ) : (
              <div className="flex items-center justify-center w-full h-full text-[--neutral-light-gray] font-medium">
                Please provide a valid YouTube URL
              </div>
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default YouTubeShowcase;